import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'monthRange',
    standalone: false
})
export class MonthRangePipe<T> implements PipeTransform {

    transform<T>(value: T, keyMin: keyof T, keyMax: keyof T): string {
        const minAmount = +value[keyMin];
        const maxAmount = +value[keyMax];

        if (minAmount && maxAmount) {
            return `De ${minAmount} à ${maxAmount} mois`;
        } else if (minAmount) {
            return `A partir de ${minAmount} mois`;
        } else if (maxAmount) {
            return `Jusqu'à ${maxAmount} mois`;
        }

        return null;
    }
}
